import searchIcon from '../../assets/search.svg';

type SearchInputProps = Readonly<{
    search: string;
    handleSearch: (value: string) => void;
    placeholder: string;
}>;

export function SearchInput({ search, handleSearch, placeholder }: SearchInputProps) {
    return (
        <div className={'relative my-6 flex w-full max-w-80'}>
            <input
                type="text"
                className="w-full text-small"
                placeholder={placeholder}
                value={search}
                onChange={e => handleSearch(e.target.value)}
            />
            <img
                src={searchIcon}
                alt=""
                className="absolute right-2 top-1/2 w-4 -translate-y-1/2"
                aria-hidden
            />
        </div>
    );
}
